import React from 'react';
import { List as ListIcon } from '@mui/icons-material';
import Tile from '../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';

const CommandJobDetails = (props) => {
  return (
    <Tile
      TitleIcon={ListIcon}
      title={'My instruments from Command job ' + props.commandJobName}
      helpTag="command_job"
    >
      <TableEnhancedContainer
        data={props.data}
        columns={props.columnConfigs}
        className="CommandJobTable"
        enableHideColumns={true}
        enableActionButtons={true}
      />
    </Tile>
  );
};

export default CommandJobDetails;
